module.exports = __webpack_public_path__ + "img/scope_reginato.68b2ee61.jpg";